<sui-button
  variant="secondary"
  [leadingIcon]="['fas', 'bolt']"
  [trailingIcon]="['fas', 'caret-down']"
  gridToolbarAction
  [label]="'grid.bulk.actions' | translate"
  [expanded]="menu.isOpen()"
  [suiMenuTrigger]="bulkMenu"
  #menu="suiMenu"
></sui-button>
<ng-template #bulkMenu>
  <sui-menu>
    <sui-menu-header>
      @if (grid.selectionCount()) {
        {{ "grid.bulk.scope.selected" | translate }} ({{
          grid.selectionCount()
        }})
      } @else {
        {{ "grid.bulk.scope.all-matching-filters" | translate }}
        ({{ grid.totalCount().toLocaleString() }})
      }
    </sui-menu-header>
    @for (item of items(); track $index) {
      @if (isSeparator(item)) {
        <sui-menu-separator></sui-menu-separator>
      } @else {
        <button sui-menu-item (click)="item.run()">
          <fa-icon [icon]="item.icon"></fa-icon>
          <span>{{ item.labelKey | translate }}</span>
        </button>
      }
    }
  </sui-menu>
</ng-template>
